import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, ExternalLink, Send } from "lucide-react";
import { http } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) { toast.error("Devi accettare l'informativa GDPR"); return; }
    setLoading(true);
    try {
      await http.post("/newsletter", { email, gdpr_consent: consent });
      toast.success("Iscrizione ricevuta. Grazie!");
      setEmail(""); setConsent(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore, riprova");
    } finally { setLoading(false); }
  };

  return (
    <footer className="mt-24 bg-viola text-cream" data-testid="site-footer">
      <div className="container-editorial py-16 grid gap-12 md:grid-cols-3">
        <div>
          <p className="font-display text-3xl leading-tight">Dania (Dan)<br />Piras</p>
          <p className="mt-4 text-cream/70 max-w-xs">Psicologə e consulente in sessuologia. Divulgazione, clinica e formazione su relazioni, sessualità, identità — con approccio affermativo e transfemminista intersezionale.</p>
          <div className="mt-6 flex gap-3">
            <a href="https://www.instagram.com/hello_policose/" target="_blank" rel="noopener noreferrer" className="grid h-10 w-10 place-items-center rounded-full border border-cream/20 hover:bg-fucsia hover:border-fucsia transition-colors" aria-label="Instagram" data-testid="social-instagram"><Instagram size={16} /></a>
            <a href="https://t.me/danpiras_psy" target="_blank" rel="noopener noreferrer" className="grid h-10 w-10 place-items-center rounded-full border border-cream/20 hover:bg-fucsia hover:border-fucsia transition-colors" aria-label="Telegram" data-testid="social-telegram"><Send size={16} /></a>
            <a href="https://linktr.ee/policose" target="_blank" rel="noopener noreferrer" className="grid h-10 w-10 place-items-center rounded-full border border-cream/20 hover:bg-fucsia hover:border-fucsia transition-colors" aria-label="Linktree" data-testid="social-linktree"><ExternalLink size={16} /></a>
            <a href="mailto:dania.piras90@gmail.com" className="grid h-10 w-10 place-items-center rounded-full border border-cream/20 hover:bg-fucsia hover:border-fucsia transition-colors" aria-label="Email" data-testid="social-email"><Mail size={16} /></a>
          </div>
          <p className="mt-6 text-xs text-cream/50">Iscritto all'Albo degli Psicologi della Lombardia — n. 22141</p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-wider text-giallo font-semibold">Navigazione</p>
          <ul className="mt-4 space-y-2 text-cream/80">
            <li><Link to="/chi-sono" className="link-underline">Chi sono</Link></li>
            <li><Link to="/aree-di-competenza" className="link-underline">Aree di competenza</Link></li>
            <li><Link to="/consulenze" className="link-underline">Consulenze</Link></li>
            <li><Link to="/supervisioni" className="link-underline">Supervisioni</Link></li>
            <li><Link to="/webinar" className="link-underline">Webinar</Link></li>
            <li><Link to="/blog" className="link-underline">Blog</Link></li>
            <li><Link to="/pubblicazioni" className="link-underline">Pubblicazioni</Link></li>
            <li><Link to="/eventi" className="link-underline">Eventi</Link></li>
            <li><Link to="/media" className="link-underline">Media</Link></li>
            <li><Link to="/contatti" className="link-underline">Contatti</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-wider text-giallo font-semibold">Newsletter</p>
          <p className="mt-4 text-cream/80">Iscriviti per ricevere articoli, nuovi webinar, pubblicazioni e riflessioni — senza spam.</p>
          <form onSubmit={submit} className="mt-4 space-y-3" data-testid="newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="la-tua@email.com"
              aria-label="Il tuo indirizzo email per la newsletter"
              autoComplete="email"
              className="w-full rounded-full bg-cream/10 border border-cream/20 px-5 py-3 text-cream placeholder-cream/50 focus:outline-none focus:ring-2 focus:ring-fucsia"
              data-testid="newsletter-email"
            />
            <label className="flex items-start gap-2 text-xs text-cream/70">
              <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" data-testid="newsletter-consent" />
              <span>Ho letto l'informativa privacy e acconsento al trattamento dei dati (art. 13 GDPR).</span>
            </label>
            <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="newsletter-submit">
              {loading ? "Invio…" : "Iscriviti"}
            </button>
          </form>
        </div>
      </div>

      <div className="border-t border-cream/10">
        <div className="container-editorial py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-cream/60">
          <p>© {new Date().getFullYear()} Dania (Dan) Piras — Tutti i diritti riservati</p>
          <p className="flex gap-3">
            <Link to="/privacy-policy" className="hover:text-cream" data-testid="footer-privacy">Privacy Policy</Link>
            <span>·</span>
            <Link to="/cookie-policy" className="hover:text-cream" data-testid="footer-cookies">Cookie Policy</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
